<template>
	<div class="flow-radio-group">
		<div
			v-for="option in options"
			:key="option.key"
			:data-selected="option.selected"
			class="flow-radio-group-option"
			@click="toggle(option)"
		>
			<slot name="option" :option="option">
				<Typography v-if="option.label" type="p2" color="light">{{ option.label }}</Typography>
			</slot>
		</div>
	</div>
</template>
<script lang="ts">
import Typography from "../Typography/Typography.vue";

import { defineComponent, PropType } from "vue";

type Option = {
	key: string;
	selected?: boolean;
	label?: string;
	[key: string]: any;
};
export default defineComponent({
	name: "RadioGroup",

	components: {
		Typography
	},

	props: {
		options: {
			type: Array as PropType<Option[]>,
			required: true,
			default: () => []
		}
	},

	methods: {
		toggle(option: Option) {
			this.options.forEach(op => {
				op.selected = false;
			});
			option.selected = !option.selected;

			/**
			 * input event for validation
			 *
			 * @event input
			 */
			this.$emit("input", option);
		}
	}
});
</script>
<style lang="scss">
div.flow-radio-group {
	display: inline-flex;
	max-height: 32px;
	height: 32px;
	padding: 0px;
	flex-shrink: 0;
	border-radius: 4px;
	overflow: hidden;
	gap: 2px;
	.flow-radio-group-option {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background-color: var(--gray-500);
		height: 100%;
		min-width: 32px;
		padding: 2px 8px;
		cursor: pointer;

		&[data-selected] {
			background-color: var(--gray-400);
		}
	}
}
</style>
